import './GradientBlock.scss';
import * as React from 'react';
type Props = {
  children: React$Node;
  className?: string;
};
type State = {
  opacity: number;
};
export default class GradientBlock extends React.Component<Props, State> {
  state = {
    opacity: 1,
  };
  node = React.createRef<HTMLDivElement>();
  updatingFromScroll = false;
  handleScroll = () => {
    if (!this.updatingFromScroll) {
      requestAnimationFrame(this.updateFromScroll);
      this.updatingFromScroll = true;
    }
  };
  updateFromScroll = () => {
    const { node } = this;
    if (!node || node.current == null) {
      return;
    }
    const position =
      (node.current.offsetTop +
        node.current.offsetHeight / 2 -
        window.scrollY) /
      window.innerHeight;
    const opacity =
      position > 0 && position < 1
        ? (Math.sin(2 * Math.PI * position - Math.PI / 2) + 1) / 2
        : 0;
    if (opacity !== this.state.opacity) {
      this.setState({
        opacity,
      });
    }
    this.updatingFromScroll = false;
  };
  componentDidMount() {
    if (window) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }
  componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }
  render() {
    const { children, className } = this.props;
    const { opacity } = this.state;
    return (
      <div className={`GradientBlock ${className}`} ref={this.node}>
        <div className="GradientBlock-overlay" style={{ opacity }} />
        {children}
      </div>
    );
  }
}
